
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Exploreindiapanindoa() {



    const cardData =
    {
        keyword: 'Explore India Pan India Innova Crysta Cab Booking Services',
        heading: 'Meghana Cab : Explore India Pan India Innova Crysta Cab Booking Services',
        headingDescription: 'Meghana Cab offers Explore India Pan India Innova Crysta Cab Booking Services, delivering a premium, reliable, and nationwide travel solution for families, corporate travelers, and group tourists seeking comfort and flexibility across the country. Whether you are planning a multi-state pilgrimage, a business circuit, a family vacation, or a long-distance intercity journey, our Innova Crysta cabs ensure maximum comfort with plush leather interiors, ample legroom, air-conditioning, and generous luggage space.',


        top: ' Top Places to Visit in India with Meghana Cab',

"topPlaces": [
  {
    "title": "Taj Mahal, Agra",
    "description": "One of the most iconic monuments in the world, the Taj Mahal is a white marble mausoleum built by Emperor Shah Jahan in memory of his wife Mumtaz Mahal. Located on the banks of the Yamuna River, this UNESCO World Heritage Site is known for its symmetrical architecture, intricate inlay work, and timeless romantic symbolism. The monument glows at sunrise and sunset, making it a favorite among photographers and travelers alike."
  },
  {
    "title": "Varanasi, Uttar Pradesh",
    "description": "One of the oldest continuously inhabited cities in the world, Varanasi is the spiritual capital of India. Situated along the banks of the Ganges River, it is known for its ghats, sacred rituals, Ganga Aarti, and maze-like old city streets. The city is deeply rooted in Hindu traditions and is considered a powerful center for spiritual cleansing and moksha (liberation)."
  },
  {
    "title": "Leh–Ladakh, Jammu & Kashmir",
    "description": "A high-altitude desert region nestled in the Himalayas, Leh–Ladakh is a haven for adventure seekers and nature lovers. Famous for Pangong Lake, Nubra Valley, and magnetic hill phenomena, it offers dramatic landscapes, Buddhist monasteries like Hemis and Thiksey, and challenging trekking and biking routes such as Khardung La Pass—one of the world’s highest motorable roads."
  },
  {
    "title": "Jaipur, Rajasthan",
    "description": "Known as the Pink City, Jaipur is a royal capital filled with magnificent forts, palaces, and vibrant markets. Highlights include the Hawa Mahal with its unique façade, the majestic Amber Fort, and the City Palace with its museum and royal courtyards. The city blends Mughal and Rajput architecture, and is part of the famous Golden Triangle tourist circuit."
  },
  {
    "title": "Kerala Backwaters",
    "description": "A unique ecosystem of interconnected canals, lagoons, and lakes, the backwaters of Kerala offer a tranquil retreat aboard traditional houseboats. Surrounded by lush greenery, coconut palms, and paddy fields, destinations like Alleppey, Kumarakom, and Vembanad Lake provide a glimpse into local life and Ayurvedic wellness culture."
  },
  {
    "title": "Goa",
    "description": "Famed for its golden beaches, Portuguese colonial architecture, and vibrant nightlife, Goa is a diverse destination that caters to both party lovers and peace seekers. From Baga and Anjuna beaches to the serene Agonda and Palolem shores, along with churches like Basilica of Bom Jesus and forts like Chapora, Goa is perfect for sun, sea, and history."
  },
  {
    "title": "Ranthambore National Park, Rajasthan",
    "description": "One of India's premier tiger reserves, Ranthambore offers thrilling jungle safaris and a chance to spot Royal Bengal tigers in their natural habitat. The park also features Ranthambore Fort, ancient ruins, lakes, and diverse wildlife including leopards, sloth bears, and marsh crocodiles."
  },
  {
    "title": "Andaman and Nicobar Islands",
    "description": "A tropical paradise of pristine beaches, turquoise waters, and coral reefs, the Andaman Islands are ideal for scuba diving, snorkeling, and marine exploration. Popular islands include Havelock and Neil Island, while attractions like Radhanagar Beach and Cellular Jail in Port Blair add cultural depth."
  },
  {
    "title": "Darjeeling, West Bengal",
    "description": "Located in the Himalayan foothills, Darjeeling is known for its tea plantations, panoramic views of Kanchenjunga, and the famous Darjeeling Himalayan Railway (a UNESCO World Heritage site). The colonial charm, cool climate, and Buddhist monasteries make it a romantic and serene getaway."
  },
  {
    "title": "Delhi",
    "description": "India’s capital city is a vibrant fusion of ancient heritage and modern dynamism. Historical sites like the Red Fort, Qutub Minar, Humayun’s Tomb, and India Gate reflect its Mughal and British colonial legacy, while bustling markets like Chandni Chowk and modern areas like Connaught Place capture its diversity."
  }
],

  "services": [
    {
      "name": "Pan India Innova Crysta Cab Booking",
      "description": "Book premium Innova Crysta cabs for travel across India with our seamless Pan India cab booking service. Whether it's a business trip, family vacation, or spiritual tour, our nationwide network ensures comfortable and reliable rides to any corner of the country."
    },
    {
      "name": "Nationwide Innova Crysta Taxi Service",
      "description": "Experience our extensive network of Innova Crysta taxis serving cities, towns, and destinations across India. We offer door-to-door service, trusted chauffeurs, and reliable vehicles for all interstate travel requirements."
    },
    {
      "name": "Interstate Innova Crysta Cab Hire",
      "description": "Travel comfortably between states with our Interstate Innova Crysta cab rentals. Our experienced drivers and long-distance-ready vehicles make every road journey smooth, safe, and efficient."
    },
    {
      "name": "India Wide Innova Crysta Taxi Booking",
      "description": "From Mumbai to Manali or Pune to Pondicherry—book your Innova Crysta cab across India. Our India-wide booking system lets you plan multi-city trips, round journeys, or one-way transfers hassle-free."
    },
    {
      "name": "Online Pan India Innova Crysta Cab",
      "description": "Use our convenient online platform to book Innova Crysta cabs anywhere in India. Enjoy transparent pricing, real-time availability, and instant confirmations for your intercity or interstate travel plans."
    },
    {
      "name": "Luxury Innova Crysta Cab Across India",
      "description": "Upgrade your nationwide travel with luxury Innova Crysta cab rentals. Leather seating, climate control, ample space, and professional service make your long routes across India a premium experience."
    },
    {
      "name": "Budget Pan India Innova Crysta Taxi",
      "description": "Looking for affordable cab travel across India? Our budget-friendly Innova Crysta rentals offer competitive pricing without compromising comfort, safety, or reliability."
    },
    {
      "name": "Chauffeur Driven Innova Crysta India Tour",
      "description": "Book chauffeur-driven Innova Crysta cabs for all-India tours. Perfect for families, NRI visitors, or group travel, our drivers are trained for long hauls and tourist itineraries across multiple states."
    },
    {
      "name": "Corporate Innova Crysta Pan India",
      "description": "Plan your nationwide business travel with our corporate Innova Crysta cabs. On-time pickups, WiFi-enabled vehicles, and discreet chauffeur service tailored for executive comfort and productivity."
    },
    {
      "name": "Family Travel Innova Crysta Pan India",
      "description": "Plan memorable India trips with family in our spacious and safe Innova Crysta cabs. Equipped for comfort and space, our vehicles are perfect for group sightseeing, pilgrimage, or holiday travel."
    },
    {
      "name": "Airport Transfer Pan India Innova Crysta",
      "description": "Get reliable airport transfer service across major Indian cities with our Innova Crysta fleet. Whether you land in Delhi, Bangalore, Hyderabad, or Chennai—we ensure timely pickups and drop-offs."
    },
    {
      "name": "Long Distance Innova Crysta Booking",
      "description": "For long-distance journeys across states and cities, choose our Innova Crysta booking service. Enjoy unmatched ride quality, luggage space, and driver professionalism for extended travel hours."
    },
    {
      "name": "Online India Innova Crysta Cab Rental",
      "description": "Rent Innova Crysta cars online from any city in India. Our web-based system lets you view rates, vehicle availability, and plan pickups/drops with ease—anytime, anywhere."
    },
    {
      "name": "Reliable Innova Crysta Cab India",
      "description": "We pride ourselves on dependable cab service across India. Our fleet is maintained to the highest standards and driven by experienced professionals for a stress-free ride—every time."
    },
    {
      "name": "All India Innova Crysta Taxi Services",
      "description": "Explore our all-India Innova Crysta taxi services designed for complete flexibility—be it state-to-state travel, multi-day bookings, or festival season tours. We’re your trusted cab partner nationwide."
    }
  ],
  "tableData": [
    ["Pan India Innova Crysta Cab Booking", "Nationwide Innova Crysta Taxi Service"],
    ["Interstate Innova Crysta Cab Hire", "India Wide Innova Crysta Taxi Booking"],
    ["Online Pan India Innova Crysta Cab", "Luxury Innova Crysta Cab Across India"],
    ["Budget Pan India Innova Crysta Taxi", "Chauffeur Driven Innova Crysta India Tour"],
    ["Corporate Innova Crysta Pan India", "Family Travel Innova Crysta Pan India"],
    ["Airport Transfer Pan India Innova Crysta", "Long Distance Innova Crysta Booking"],
    ["Online India Innova Crysta Cab Rental", "Reliable Innova Crysta Cab India"],
    ["All India Innova Crysta Taxi Services", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pan India Innova Crysta Cab Booking Services",
    "WhyChoosedescription": "Explore India with ease and comfort by booking our Innova Crysta cabs available across major cities and states. Whether it’s a city tour, outstation trip, or long-distance travel, our Pan India service connects you to reliable rides wherever you go."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Vehicles for Every Journey",
    "WhyChoosedescription": "Our Innova Crysta cars provide ample seating for up to 7 passengers, along with spacious luggage capacity, premium interiors, and powerful air conditioning—ensuring a comfortable journey across diverse Indian terrains and climates."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pan India Routes",
    "WhyChoosedescription": "Our chauffeurs are well-trained, courteous, and knowledgeable about routes in different regions of India. From metropolitan cities to remote destinations, they ensure safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Well-Maintained, Hygienic, and Sanitized Vehicles",
    "WhyChoosedescription": "We maintain rigorous standards for vehicle cleanliness and mechanical upkeep, providing sanitized and fully serviced Innova Crysta cars to guarantee your safety and comfort throughout your journey."
  },
  {
    "WhyChooseheading": "Flexible Booking Options with Customized Itineraries",
    "WhyChoosedescription": "Whether you need a cab for a few hours, full-day city tours, multi-day outstation trips, or special events, our services are tailored to your schedule and preferences. Customize pickup/drop points, routes, and travel durations with ease."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing model covers all essential costs, including driver allowances, fuel, tolls, taxes, and parking fees. We offer clear, upfront quotes to help you plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Ideal for Corporate Travel, Family Vacations, and Group Tours",
    "WhyChoosedescription": "Whether it’s business trips, leisure vacations, or group excursions, our Innova Crysta cab services deliver the convenience, reliability, and comfort that every traveler expects."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking Experience",
    "WhyChoosedescription": "Our dedicated customer service team is available around the clock to assist with bookings, route planning, special requests, and any travel assistance you may need during your journey."
  }
]


























    }

const faqData = [
    {
        question: "Does Meghana Cab offer Innova Crysta booking services across India?",
        answer: "Yes, we provide Pan India Innova Crysta cab booking services for intercity and outstation travel across major cities and states."
    },
    {
        question: "How do I book an Innova Crysta for multi-state or long-distance travel?",
        answer: "You can book easily by calling us at +91 9075462128 or through our website by selecting your pickup and drop locations."
    },
    {
        question: "Is Innova Crysta ideal for long journeys across India?",
        answer: "Absolutely. With comfortable seating for 6–7 passengers and superior suspension, it’s perfect for long, intercity trips."
    },
    {
        question: "Which cities and destinations do you cover with Pan India service?",
        answer: "We cover all major metros and tourist destinations including Delhi, Mumbai, Goa, Hyderabad, Bangalore, Chennai, Jaipur, and more."
    },
    {
        question: "Can I book an Innova Crysta for a multi-day road trip across states?",
        answer: "Yes, you can book the cab for multi-day tours or custom itineraries. We offer flexible packages tailored to your needs."
    },
    {
        question: "Are the drivers experienced with interstate travel and tourism routes?",
        answer: "Yes, our drivers are highly experienced, licensed, and trained for long-distance and multi-state routes."
    },
    {
        question: "What is included in the Pan India Innova Crysta rental fare?",
        answer: "The fare includes fuel, driver charges, tolls, and state permits. Parking or extra night halts may incur additional charges."
    },
    {
        question: "Is the vehicle sanitized and well-maintained for long trips?",
        answer: "Yes, every Innova Crysta is regularly maintained and fully sanitized before each trip for maximum safety and comfort."
    },
    {
        question: "Can I request sightseeing or stopovers during the journey?",
        answer: "Yes, the itinerary can include sightseeing, meal stops, and custom halts upon prior request."
    },
    {
        question: "What are the payment options for Pan India bookings?",
        answer: "We accept UPI, debit/credit cards, bank transfers, and cash for your convenience."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Sharma',
        designation: 'Corporate Client',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Innova Crysta from Pune to Bangalore. Excellent long-distance travel experience. Comfortable, clean, and punctual.”',
    },
    {
        name: 'Ms. Priya Menon',
        designation: 'Traveler',
        rating: [1, 1, 1, 1, 1],
        text: '“Our road trip from Mumbai to Rajasthan was amazing with Meghana Cab. The Crysta was top-notch, and the driver was very cooperative.”',
    },
];










































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const panIndiaInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pan India Innova Crysta Cab Booking Services",
  "description": "Reliable chauffeur-driven Innova Crysta taxi services available across India for corporate, family, airport transfers, and long-distance interstate travel. Book online for budget and luxury options.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Pan India Taxi Service",
  "areaServed": "IN",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pan-india-innova-crysta-cab-booking"
  }
};





    return (
        <div>



<Helmet>
  <title>Pan India Innova Crysta Cab Booking | Nationwide Taxi Service</title>
  <meta
    name="description"
    content="Book reliable chauffeur-driven Innova Crysta cabs across India. Affordable and luxury options for corporate travel, family trips, airport transfers, and interstate tours with online booking."
  />
  <meta
    name="keywords"
    content="Pan India Innova Crysta Cab Booking, Nationwide Innova Crysta Taxi Service, Interstate Innova Crysta Cab Hire, India Wide Innova Crysta Taxi Booking, Online Pan India Innova Crysta Cab, Luxury Innova Crysta Cab Across India, Budget Pan India Innova Crysta Taxi, Chauffeur Driven Innova Crysta India Tour, Corporate Innova Crysta Pan India, Family Travel Innova Crysta Pan India, Airport Transfer Pan India Innova Crysta, Long Distance Innova Crysta Booking, Online India Innova Crysta Cab Rental, Reliable Innova Crysta Cab India, All India Innova Crysta Taxi Services"
  />
  <script type="application/ld+json">
    {JSON.stringify(panIndiaInnovaSchema)}
  </script>
</Helmet>
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Exploreindiapanindoa;